import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormRadioGroupField, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Container, RadioButton } from '@optimus-web/core';
import { Service } from '@mews-commander/data-access';
import { CustomItemsFormFields, CustomItemsOptionsNames } from '../../../../../schemas';
import { RoutingRulesFormFields } from '../../../utils';
import { useAccountingCategoriesOption } from './hooks';

export const CustomItemsSelectField = ({ service }: { service: Service }) => {
    const { watch, setValue } = useFormContext();
    const customItemsFieldName = RoutingRulesFormFields.customItems(service.id);
    const customItemsTypeFieldName = `${customItemsFieldName}.${CustomItemsFormFields.Type}`;
    const customItemsType = watch(customItemsTypeFieldName);

    const productsFieldName = RoutingRulesFormFields.additionalServiceProducts(service.id);
    const { accountingCategoriesOption, accountingCategoriesDialog } = useAccountingCategoriesOption({
        service,
        parentFieldName: customItemsFieldName,
        reflectedFieldName: productsFieldName,
    });

    useEffect(() => {
        if (customItemsType == null) {
            setValue(customItemsTypeFieldName, CustomItemsOptionsNames.All);
        }
    }, [setValue, customItemsTypeFieldName, customItemsType]);

    return (
        <Container padding={['200', '0']}>
            <FormRadioGroupField name={customItemsTypeFieldName} label={lt(TextKey.RoutingRulesFormCustomItemsLabel)}>
                <RadioButton
                    label={lt(TextKey.RoutingRulesFormAllCustomItemsOption)}
                    value={CustomItemsOptionsNames.All}
                    key={CustomItemsOptionsNames.All}
                />
                {accountingCategoriesOption}
            </FormRadioGroupField>
            {accountingCategoriesDialog}
        </Container>
    );
};
